/**
 * PreparedForLine — no-op.
 *
 * The "Prepared for: {archetype}" header (and its editor-mode amber
 * "Overridden" chip + admin edit pencil) was removed from the report
 * cover on 2026-05-11 — it cluttered the header and the customer's
 * PDF. The audience archetype still frames the narrative (and is
 * editable from the report-preferences preflight); it's just no longer
 * printed on the cover.
 *
 * The component is kept (rather than ripped out of the four cover
 * layouts that mount it) so those layouts can keep passing the same
 * props harmlessly. If the line ever comes back, restore the render
 * here — git history pre-2026-05-11 has the original.
 */
import React from 'react';
import type { SiteRagReport } from '../../types/siteRag';
import type { CompanyArchetype } from '../../types/company';

export interface PreparedForLineProps {
  report: SiteRagReport;
  isAdmin: boolean;
  /** Toggle the inline archetype-picker dropdown. (No-op now.) */
  onTogglePicker?: () => void;
  /** Whether the picker is currently open. (No-op now.) */
  pickerOpen?: boolean;
  /** Apply a new archetype override (or pass `undefined` to revert). (No-op now.) */
  onSelectArchetype?: (next: CompanyArchetype | undefined) => void;
}

export function PreparedForLine(_props: PreparedForLineProps): React.ReactElement | null {
  return null;
}
